<script setup>
defineProps({
  items: {
    type: Array,
    default: () => [],
  },
});
</script>
<template>
  <div class="card border-0 shadow-sm rounded-4 h-100">
    <div class="card-body p-4">
      <div class="d-flex justify-content-between align-items-center mb-4">
        <div>
          <h5 class="fw-bold mb-1">Insight สำคัญ</h5>
          <div class="text-muted small">
            สรุปข้อค้นพบสำคัญจากรายงานในปีที่เลือก
          </div>
        </div>
        <i class="bi bi-lightbulb text-warning fs-4"></i>
      </div>

      <div class="vstack gap-3">
        <div
          v-for="item in items"
          :key="item.id"
          class="border rounded-4 p-3"
          :class="`border-${item.type} border-opacity-25`"
        >
          <div class="d-flex align-items-start gap-3">
            <div
              class="insight-icon"
              :class="`bg-${item.type}-subtle text-${item.type}`"
            >
              <i class="bi bi-stars"></i>
            </div>
            <div>
              <div class="fw-semibold mb-1">{{ item.title }}</div>
              <div class="text-muted small">{{ item.description }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<style scoped>
.insight-icon {
  width: 42px;
  height: 42px;
  border-radius: 14px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 1rem;
  flex-shrink: 0;
}
</style>
